import { GetSurveyRulesRPC } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRulesRPC";
import { GetSurveyRulesRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRulesRPCClientImpl";
import { MOCK } from "@pulse/shared-components";
import { APIClient } from "@surya-digital/tedwig";
import { MockGetSurveyRulesRPCClientImpl } from "./MockGetSurveyRulesRPCClientImpl";
import { SaveSurveyRulesRPC } from "@pulse/pulse-rpcs/lib/survey-rules/saveSurveyRulesRPC";
import { SaveSurveyRulesRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/saveSurveyRulesRPCClientImpl";
import { MockSaveSurveyRulesRPCClientImpl } from "./MockSaveSurveyRulesRPCClientImpl";
import { GetSurveyRuleKeyOptionsRPC } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRuleKeyOptionsRPC";
import { GetSurveyRuleKeyOptionsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRuleKeyOptionsRPCClientImpl";
import { MockGetSurveyRuleKeyOptionsRPCClientImpl } from "./MockGetSurveyRuleKeyOptionsRPCClientImpl";
import { GetSurveyRuleValueOptionsRPC } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRuleValueOptionsRPC";
import { GetSurveyRuleValueOptionsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRuleValueOptionsRPCClientImpl";
import { MockGetSurveyRuleValueOptionsRPCClientImpl } from "./MockGetSurveyRuleValueOptionsRPCClientImpl";
import { GetSurveyRuleTargetOptionsRPC } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRuleTargetOptionsRPC";
import { GetSurveyRuleTargetOptionsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/getSurveyRuleTargetOptionsRPCClientImpl";
import { MockGetSurveyRuleTargetOptionsRPCClientImpl } from "./MockGetSurveyRuleTargetOptionsRPCClientImpl";

export const useGetSurveyRulesRPCClientImpl = (
  apiClient: APIClient,
): GetSurveyRulesRPC =>
  MOCK.surveyRules
    ? new MockGetSurveyRulesRPCClientImpl()
    : new GetSurveyRulesRPCClientImpl(apiClient);

export const useGetSurveyRuleKeyOptionsRPCClientImpl = (
  apiClient: APIClient,
): GetSurveyRuleKeyOptionsRPC =>
  MOCK.surveyRules
    ? new MockGetSurveyRuleKeyOptionsRPCClientImpl()
    : new GetSurveyRuleKeyOptionsRPCClientImpl(apiClient);

export const useGetSurveyRuleValueOptionsRPCClientImpl = (
  apiClient: APIClient,
): GetSurveyRuleValueOptionsRPC =>
  MOCK.surveyRules
    ? new MockGetSurveyRuleValueOptionsRPCClientImpl()
    : new GetSurveyRuleValueOptionsRPCClientImpl(apiClient);

export const useGetSurveyRuleTargetOptionsRPCClientImpl = (
  apiClient: APIClient,
): GetSurveyRuleTargetOptionsRPC =>
  MOCK.surveyRules
    ? new MockGetSurveyRuleTargetOptionsRPCClientImpl()
    : new GetSurveyRuleTargetOptionsRPCClientImpl(apiClient);

export const useSaveSurveyRulesRPCClientImpl = (
  apiClient: APIClient,
): SaveSurveyRulesRPC =>
  MOCK.surveyRules
    ? new MockSaveSurveyRulesRPCClientImpl()
    : new SaveSurveyRulesRPCClientImpl(apiClient);
